import { render, staticRenderFns } from "./IeWarning.vue?vue&type=template&id=1a843f94&"
import script from "./IeWarning.vue?vue&type=script&lang=js&"
export * from "./IeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports